var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onWindowResize),expression:"onWindowResize"}],attrs:{"anchor-root":"","device":_vm.device}},[_c('router-view'),(_vm.applicationLoaded)?_c('appExtra'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }